import React from 'react'
import { Button, Flex, Popconfirm, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { DeleteOutlined } from '@ant-design/icons'
import { CustomerSelect } from '../../../customer'
import { SupplierSelect } from '../../../supplier'

export interface RecordFormState {
  localCompanyId: string
  sourceId: string
  id?: number
}

interface RecordRowProps {
  role?: string
  roleKey: 'customer' | 'supplier'
  companyId?: string
  form: RecordFormState
  onChange: (form: RecordFormState) => void
  onDelete: () => void
  deleting?: boolean
  // Source ids already picked by sibling rows, hidden from this row's list.
  excludeValues?: string[]
}

const RecordRow: React.FC<RecordRowProps> = ({
  role,
  roleKey,
  companyId,
  form,
  onChange,
  onDelete,
  deleting,
  excludeValues
}) => {
  const { t } = useTranslation()
  const isComplete = !!form.id
  const SourceSelect = roleKey === 'customer' ? CustomerSelect : SupplierSelect

  return (
    <div>
      <div>
        {role && <Typography.Text style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>{role}</Typography.Text>}
        <Flex gap={8}>
          <SourceSelect
            allowClear
            style={{ flex: 1 }}
            companyId={companyId}
            excludeValues={excludeValues}
            value={form.sourceId || undefined}
            status={isComplete ? undefined : 'warning'}
            placeholder={t('groupCustomerMapping:pairSelectSource', 'valitse lähdetieto…')}
            onChange={value => onChange({ ...form, sourceId: value })}
          />
          <Popconfirm
            title={t('groupCustomerMapping:pairDeleteConfirm', 'Poistetaanko linkitys?')}
            onConfirm={onDelete}
            okText={t('global:yes', 'Kyllä')}
            cancelText={t('global:no', 'Ei')}
            disabled={!isComplete}
          >
            <Button danger disabled={!isComplete} loading={deleting} icon={<DeleteOutlined />} />
          </Popconfirm>
        </Flex>
      </div>
    </div>
  )
}

export default RecordRow
